import http from '@core/fetch'
import { API_SETMEAL_LIST } from '@constant'

export default {
  setMealListApi: params =>
    http(API_SETMEAL_LIST, {
      body: params
    }), //普通套餐列表
  choseThemeApi: params =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/chose_theme', {
      body: params
    }), //选择主题
  decorationApi: params =>
    http('/p/wedding/index.php/home/APIMerchant/decoration', {
      body: params
    }) //获取店铺服务（收费）配置
}
